function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var StreamMirror = /*#__PURE__*/function () {
  function StreamMirror(app, mod) {
    var _this = this;
    _classCallCheck(this, StreamMirror);
    this.app = app;
    this.mod = mod;
    this.streams = new Map();
    console.log('********************', 'Use Stream Mirroring', '***********************');
    app.connection.on('add-local-stream-request', function (localStream) {
      _this.addStream(localStream, 'local');
    });
    app.connection.on('add-remote-stream-request', function (peer, remoteStream) {
      _this.addStream(remoteStream, peer);
    });
    app.connection.on('remove-peer-box', function (peer_id) {
      _this.removeStream(peer_id);
    });
  }
  return _createClass(StreamMirror, [{
    key: "addStream",
    value: function addStream(stream, id) {
      var gameMenu = document.getElementById('game-menu');
      if (!gameMenu) return;
      if (this.streams.has(id)) {
        this.updateStream(stream, id);
        return;
      }
      var videoContainer = document.createElement('div');
      videoContainer.className = 'video-overlay-container';
      videoContainer.style.cssText = 'position: relative; width: 100%;';
      var video = document.createElement('video');
      video.id = "mirror-".concat(id);
      video.autoplay = true;
      video.muted = true;
      video.srcObject = stream;
      video.style.cssText = 'width: 100%; height: 100%; object-fit: cover;';
      videoContainer.appendChild(video);
      if (id === 'local') {
        var controlPanel = this.createControlPanel();
        videoContainer.appendChild(controlPanel);
      }
      this.streams.set(id, videoContainer);
      if (this.placeVideoInPlayerBox(videoContainer, id)) {
        this.adjustChatbox(id);
      }
    }
  }, {
    key: "createControlPanel",
    value: function createControlPanel() {
      var controlPanel = document.createElement('div');
      controlPanel.className = 'video-control-panel';
      controlPanel.style.cssText = "\n            position: absolute;\n            bottom: 10px;\n            left: 50%;\n            transform: translateX(-50%);\n            display: flex;\n            gap: 10px;\n            background: rgba(0, 0, 0, 0.5);\n            padding: 5px 10px;\n            border-radius: 8px;\n            z-index: 10;\n        ";
      var originalControls = document.querySelector('.control-panel');
      if (originalControls) {
        var originalAudio = originalControls.querySelector('.audio-control');
        var originalVideo = originalControls.querySelector('.video-control');
        var originalDisconnect = originalControls.querySelector('.disconnect-control');
        var controls = [{
          original: originalAudio,
          className: 'audio-control'
        }, {
          original: originalVideo,
          className: 'video-control'
        }, {
          original: originalDisconnect,
          className: 'disconnect-control'
        }].map(function (_ref) {
          var original = _ref.original,
            className = _ref.className;
          var newControl = document.createElement('div');
          newControl.className = "".concat(className, " icon_click_area");
          var originalIcon = original.querySelector('i');
          if (originalIcon) {
            newControl.innerHTML = originalIcon.outerHTML;
          }
          newControl.addEventListener('click', function () {
            original.click();
            if (className === 'audio-control') {
              newControl.classList.toggle('disabled');
              var icon = newControl.querySelector('i');
              icon.classList.toggle('fa-microphone-slash');
              icon.classList.toggle('fa-microphone');
            } else if (className === 'video-control') {
              newControl.classList.toggle('disabled');
              var _icon = newControl.querySelector('i');
              _icon.classList.toggle('fa-video-slash');
              _icon.classList.toggle('fa-video');
            }
          });
          newControl.style.cssText = "\n                    cursor: pointer;\n                    padding: 5px;\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    color: white;\n                ";
          newControl.addEventListener('mouseenter', function () {
            newControl.style.opacity = '0.8';
          });
          newControl.addEventListener('mouseleave', function () {
            newControl.style.opacity = '1';
          });
          return newControl;
        });
        controls.forEach(function (control) {
          return controlPanel.appendChild(control);
        });
        originalControls.remove();
      }
      return controlPanel;
    }
  }, {
    key: "removeVideoByPublicKey",
    value: function removeVideoByPublicKey(id) {
      var streamContainer = document.getElementById("stream_".concat(id));
      if (streamContainer) {
        var videoElement = streamContainer.querySelector('video');
        if (videoElement) {
          videoElement.style.display = 'none';
        }
      }
    }
  }, {
    key: "adjustChatbox",
    value: function adjustChatbox(id) {
      this.removeVideoByPublicKey(id);
      var chatbox = document.querySelector('#stun-chatbox-box');
      if (chatbox) {
        chatbox.style.display = 'none';
        chatbox.style.height = '10rem';
        chatbox.style.minHeight = 0;
        var section = chatbox.querySelector('.stun-chatbox .video-container-large');
        section.style.display = 'none';
        var minimizer = chatbox.querySelector('.minimizer');
        minimizer.style.display = 'none';
        var footer = chatbox.querySelector('.footer');
        footer.style.height = '10rem';
      }
    }
  }, {
    key: "placeVideoInPlayerBox",
    value: function placeVideoInPlayerBox(videoContainer, peerId) {
      var gottenAddress = peerId === 'local' ? this.mod.publicKey : peerId;
      var playerBoxes = document.querySelectorAll('.game-video-container');
      var placed = false;
      var _iterator = _createForOfIteratorHelper(playerBoxes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var box = _step.value;
          var address = box.querySelector('.saito-address').getAttribute('data-id');
          if (address) {
            if (address === gottenAddress) {
              box.appendChild(videoContainer);
              placed = true;
              break;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return placed;
    }
  }, {
    key: "updateStream",
    value: function updateStream(stream, id) {
      var videoContainer = this.streams.get(id);
      if (videoContainer) {
        var video = videoContainer.querySelector('video');
        if (video) {
          video.srcObject = stream;
        }
      }
    }
  }, {
    key: "removeStream",
    value: function removeStream(id) {
      var videoContainer = this.streams.get(id);
      if (videoContainer) {
        videoContainer.remove();
        this.streams["delete"](id);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.streams.forEach(function (container) {
        return container.remove();
      });
      this.streams.clear();
    }
  }]);
}();
module.exports = StreamMirror;